// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "e5c37754dc51a912","396": "68f2945177178ebc","460": "998593702f25e1a0","498": "8e60423fb963c507","917": "521ff7302c98628d","985": "72118aa96de01fc2",}[chunkId] + ".chunk.js"
}